import {showMessage} from "@app/constants/Messages";
import {GpCddProcess, ProcessPriority, TodoWCdd} from "@pages/dvtjcuv/common/Constant";
import {optionsToArray, optionsToString, strEqual} from "@app/utils/CommonUtils";


export const validatePipelineInputBeforeSave = (pipeline) => {
    if (!pipeline.cdd_id && !pipeline.cdd_receiver_id) {
        showMessage("Vui lòng nhập Cdd ID hoặc Cdd Receiver ID")
        return false;
    }

    // if (!pipeline.cdd_receiver_id) {
    //     showMessage("Vui lòng nhập Cdd Receiver ID")
    //     return false
    // }

    if (strEqual(optionsToString(pipeline.to_do_w_cdd), TodoWCdd.PAUSE_PROCESS_W_DVTJCUV) && !pipeline.next_fu_schedule_date_time) {
        const currentDate = new Date();
        const nextFUScheduleDate = new Date(currentDate.setMonth(currentDate.getMonth() + 6));
        pipeline.next_fu_schedule_date_time = nextFUScheduleDate.toISOString().slice(0, 10)
        showMessage("Vui lòng nhập FU Schedule!")
        return false
    }

    if (strEqual(optionsToString(pipeline.process_priority, false), ProcessPriority.YES.value)) {
        if (window.confirm("Bạn đang nhập [Ưu tiên xử lý] cho dòng này. Bạn có chắc chắn không?") !== true) {
            return false
        }

    }

    // Validate gp cdd process service actived.
    const arrGpCddProcesses = optionsToArray(pipeline.gp_cdd_process)
    const lowerGpCddProcesses = arrGpCddProcesses.map(item => item.toLowerCase());
    if (lowerGpCddProcesses.includes(GpCddProcess.SERVICE_ACTIVATED.toLowerCase())) {
        if (window.confirm("Bạn đang nhập [Service activated] cho dòng này. Bạn có chắc chắn không?") !== true) {
            return false
        }

    }

    // if (strEqual(optionsToString(pipeline.gp_cdd_process, false), GpCddProcess.CDD_ACTIVATION_FEE_PAYMENT)) {
    //     if (window.confirm("Bạn đang nhập [Cdd thanh toán phí kích hoạt]. Bạn có chắc chắn không?") !== true) {
    //         return false
    //     }
    //
    // }


    return true

}

export const validateDMYInput = (day, month, year) => {
    // Cho phép bỏ trống tất cả
    if ((day === undefined || day === '' || day === null)
        && (month === undefined || month === '' || month === null)
        && (year === undefined || year === '' || year === null)) {
        return true;
    }

    // Chuẩn hóa kiểu dữ liệu sang số nguyên khi có nhập
    const parseIntSafe = (val) => {
        if (val === undefined || val === '' || val === null) return undefined;
        const n = Number(val);
        return Number.isFinite(n) ? Math.trunc(n) : NaN;
    };

    const d = parseIntSafe(day);
    const m = parseIntSafe(month);
    const y = parseIntSafe(year);

    const isProvided = (val) => val !== undefined;

    // Year: nếu có nhập thì phải trong [1900, currentYear]
    if (isProvided(y)) {
        const currentYear = new Date().getFullYear();
        if (!Number.isInteger(y) || y < 1900 || y > currentYear) {
            return false;
        }
    }

    // Month: nếu có nhập thì 1..12
    if (isProvided(m)) {
        if (!Number.isInteger(m) || m < 1 || m > 12) {
            return false;
        }
    }

    // Day: nếu có nhập thì 1..31 và bắt buộc có month
    if (isProvided(d)) {
        if (!Number.isInteger(d) || d < 1 || d > 31) {
            return false;
        }
        // bắt buộc có month nếu có day
        if (!isProvided(m)) {
            return false;
        }

        // Ràng buộc ngày theo tháng (xét năm nhuận nếu có year)
        const thirtyDayMonths = [4, 6, 9, 11];
        if (m === 2) {
            // Tính năm nhuận nếu có y, nếu không có y thì chấp nhận tối đa 29
            let maxFeb = 29;
            if (isProvided(y)) {
                const isLeap = (y % 4 === 0 && y % 100 !== 0) || (y % 400 === 0);
                maxFeb = isLeap ? 29 : 28;
            }
            if (d > maxFeb) {
                return false;
            }
        } else if (thirtyDayMonths.includes(m)) {
            if (d > 30) {
                return false;
            }
        } else if (d > 31) {
            return false;
        }
    }

    return true;
}
